import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5","key":"svg-0"}],["path",{"d":"M4 13h7","key":"svg-1"}],["path",{"d":"M21 12h-6","key":"svg-2"}]]

const IconTextDecrease = createReactComponent('outline', 'text-decrease', 'TextDecrease', __iconNode);

export default IconTextDecrease;